<template>
  <section class="story-detail">
    <div class="banner">
      <div class="left flex container-main">
        <div class="left-body card-border-box">
          <div class="title">{{ info.title }}</div>
          <div class="desc">{{ info.subTitle }}</div>
        </div>
      </div>
      <div class="img-box">
        <img :src="info.bannerUrl" width="1920" height="700" />
      </div>
    </div>
    <div class="short-list-item ql-editor">
      <div class="short-main" v-html="info.content"></div>
    </div>
  </section>
</template>

<script>
import request, { previewImg } from '../../utils/request'
export default {
  name: 'StoryDetail',
  components: {},
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      request({
        url: '/article/getInfo/' + this.$route.query.id,
        method: 'post'
      }).then(res => {
        this.info = res.data
        this.info.bannerUrl = previewImg(this.info.bannerUrls)
        this.info.content = decodeURIComponent(this.info.content)
        this.info.introduction = decodeURIComponent(this.info.introduction)
        console.log('res', res)
      })
    }
  }
}
</script>

<style scoped lang="less">
.banner {
  height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  .left {
    z-index: 1;
    .left-body {
      background: #fff;
      width: 570px;
      min-height: 290px;
      padding-block-start: 50px;
      padding-block-end: 30px;
      padding-inline-start: 65px;
      padding-inline-end: 50px;
      .title {
        font-size: 32px;
        font-weight: bold;
        margin: 10px 0 30px;
      }
      .desc {
        font-size: 26px;
        margin-bottom: 10px;
      }
    }
  }
  .img-box {
    position: absolute;
    top: 0;
    right: 0;
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s, transform var(--e-transform-transition-duration, 0.4s);
    text-align: right;
    img {
      width: 70vw;
      height: 500px;
      object-fit: cover;
      object-position: center center;
      vertical-align: middle;
      display: inline-block;
      max-width: 100%;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }
}
.short-list-item {
  background-color: #fbfbfc;
  padding: 60px 0;
  &:nth-child(2n + 1) {
    background-color: #fff;
  }
  .author-box {
    gap: 20px;
    padding-bottom: 60px;
    font-size: 16px;
    .left {
      width: 54px;
      height: 54px;
    }
    .right {
      flex: 1;
      font-size: 20px;
      .fy {
        font-family: 'Poppins', Sans-serif;
        font-weight: 400;
        font-style: italic;
        line-height: 1.3em;
      }
      .author {
        margin-top: 30px;
        color: #f15a2c;
        font-size: 22px;
        margin-bottom: 10px;
      }
    }
  }

  .scheme-intro {
    min-height: 200px;
    padding: 0 30px;
    font-size: 16px;
    ul {
      list-style: disc;
      font-weight: bold;
      margin-top: 30px;
      padding-left: 10px;
      li {
        padding: 5px 0;
      }
      h4 {
        font-weight: bold;
      }
    }
  }
  .scheme-desc {
    h3 {
      font-size: 20px;
      padding-bottom: 30px;
    }
    p {
      padding-bottom: 20px;
      line-height: 1.7;
    }
    ul {
      list-style: disc;
      margin-left: 30px;
      li {
        padding: 5px 0;
      }
    }
    h4 {
      margin: 10px 0;
    }
  }
  img {
    max-width: 100%;
  }
}
</style>
